import { storeToRefs } from 'pinia';

import { USER_SETTINGS_BY_PAGE_STORAGE_KEY, USER_SETTINGS_BY_USER_STORAGE_KEY } from '@/constants/storage';
import { PartialUserSettings, UserSettings, UserSettingsByPage, UserSettingsByUser } from '@/models/user';
import { useUserStore } from '@/piniaStores/user/user.store';

interface SettingsOptions {
  global: boolean;
  [K: string]: unknown;
}

/**
 * Retrieve user settings by page from localStorage
 */
export function getUserSettingsByPageStorage() {
  const storedSettingsByPageData = localStorage.getItem(USER_SETTINGS_BY_PAGE_STORAGE_KEY);
  const userSettingsByPage: UserSettingsByPage = storedSettingsByPageData ? JSON.parse(storedSettingsByPageData) : {};

  return userSettingsByPage;
}

/**
 * Retrieve user settings by user from localStorage
 */
export function getUserSettingsByUserStorage() {
  const storedSettingsByUserData = localStorage.getItem(USER_SETTINGS_BY_USER_STORAGE_KEY);
  const userSettingsByUser: UserSettingsByUser = storedSettingsByUserData ? JSON.parse(storedSettingsByUserData) : {};

  return userSettingsByUser;
}

/**
 * User setting persistence utility function
 * @deprecated use useUserStore directly
 * @TODO We should get rid of these and just use the store getters directly
 */
export function setUserSetting<K extends keyof UserSettings>(
  name: K,
  data: PartialUserSettings<K>,
  options: SettingsOptions = { global: false },
) {
  const { setUserSettingsByPage } = useUserStore();

  setUserSettingsByPage({
    name,
    data,
    options,
  });
}

/**
 * User setting retrieval utility function
 * @deprecated use useUserStore directly
 * @TODO We should get rid of these and just use the store getters directly
 */
export function getUserSetting<K extends keyof UserSettings>(name: K, options: SettingsOptions = { global: false }) {
  const { getUserSettingsByPage } = storeToRefs(useUserStore());

  return getUserSettingsByPage.value(name, options);
}

/**
 * User setting remove utility function
 * @deprecated use useUserStore directly
 * @TODO We should get rid of these and just use the store getters directly
 */
export function removeUserSetting(name: keyof UserSettings, options: SettingsOptions = { global: false }) {
  const { removeUserSettingsByPage } = useUserStore();

  removeUserSettingsByPage({
    name,
    options,
  });
}
